/* eslint-disable */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import { createInterviewFollowup } from './interviewFollowup';

const generateSimpleFollowupQuestion = httpsCallable(functions, 'generateFollowupQuestionClean', { timeout: 130000 });

// Canonical Firebase Functions API
// Single source of truth for all Firebase function calls
export const fn = {
  // AI and Question Generation
  generateFollowupQuestions: createInterviewFollowup(generateSimpleFollowupQuestion),
  generateSimpleFollowupQuestion,
  generateEnhancedStoryPrompts: httpsCallable(functions, 'generateEnhancedStoryPrompts'),
  generateSmartFollowupQuestions: httpsCallable(functions, 'generateSmartFollowupQuestions', { timeout: 300000 }), // 5 min timeout for GPT-5 with large context
  generateCollaborativeQuestions: httpsCallable(functions, 'generateCollaborativeQuestions'),
  generateCollaborativeStoryPrompts: httpsCallable(functions, 'generateCollaborativeStoryPrompts'),
  generateInitialQuestions: httpsCallable(functions, 'generateInitialQuestions'),

  // Audio and Transcription
  transcribeAudio: httpsCallable(functions, 'transcribeAudio'),
  manualTranscribe: httpsCallable(functions, 'manualTranscribe'),
  aiCleanupTranscript: httpsCallable(functions, 'aiCleanupTranscript'),
  cleanupTranscription: httpsCallable(functions, 'cleanupTranscription'),
  updateTranscription: httpsCallable(functions, 'updateTranscription'),

  // Story Management
  compileStoryForPDF: httpsCallable(functions, 'compileStoryForPDF'),
  deleteStoryCompletely: httpsCallable(functions, 'deleteStoryCompletely'),
  deleteQuestionCompletely: httpsCallable(functions, 'deleteQuestionCompletely'),
  getQuestionAnswerThread: httpsCallable(functions, 'getQuestionAnswerThread'),
  reorderQuestions: httpsCallable(functions, 'reorderQuestions'),

  // User Management
  getUserStats: httpsCallable(functions, 'getUserStats'),
  updateUserProfile: httpsCallable(functions, 'updateUserProfile'),
  sendPasswordResetEmail: httpsCallable(functions, 'sendPasswordResetEmail'),

  // Collaboration and Sharing
  joinCollaborativeStory: httpsCallable(functions, 'joinCollaborativeStory'),
  getCollaborativeStories: httpsCallable(functions, 'getCollaborativeStories'),
  shareStoryViaEmail: httpsCallable(functions, 'shareStoryViaEmail'),
  addStoryHelper: httpsCallable(functions, 'addStoryHelper'),
  generateGiftStoryLink: httpsCallable(functions, 'generateGiftStoryLink'),
  getSharedStories: httpsCallable(functions, 'getSharedStories'),

  // Gift Story Functions
  sendCollaboratorInvitation: httpsCallable(functions, 'sendCollaboratorInvitation'),
  sendGiftStoryNotification: httpsCallable(functions, 'sendGiftStoryNotification'),
  resendGiftStoryNotification: httpsCallable(functions, 'resendGiftStoryNotification'),
  updateGiftRecipientEmail: httpsCallable(functions, 'updateGiftRecipientEmail'),

  // Story Reminders
  setStoryReminder: httpsCallable(functions, 'setStoryReminder'),
  getStoryReminder: httpsCallable(functions, 'getStoryReminder'),
  // Collaboration utility (new)
  ackCollaboratorPresence: httpsCallable(functions, 'ackCollaboratorPresence'),

  // Demo Functions
  createDemoUser: httpsCallable(functions, 'createDemoUser'),
  createDemoStory: httpsCallable(functions, 'createDemoStory'),
  uploadDemoAudio: httpsCallable(functions, 'uploadDemoAudio', { timeout: 300000 }), // 5 min for Whisper
};

// Type-safe function call helper (optional - for TypeScript projects)
export const FunctionName = Object.keys(fn);

